<template>
    <form-file
        v-bind="$attrs"
        v-on="$listeners"
        ref="formFile"
        :placeholder="placeholder"
        :drop-placeholder="dropPlaceholder"
        :type="type"
    />
</template>

<script>
    import FormFile from '../form-file/form-file.vue';

    export default {
        components: { FormFile },
        props: {
            placeholder: {
                type: String,
                default: 'Drag and Drop your files here or click to upload',
            },
            dropPlaceholder: {
                type: String,
                default: 'Drop your photos',
            },
            type: {
                type: String,
                default: 'file',
            },
        },
    };
</script>

<style lang="scss" scoped>
    :deep(.custom-file, .custom-file-input, .custom-file-label) {
        height: 10rem !important;
    }

    :deep(.custom-file-label, .custom-file-label:after) {
        display: flex;
        justify-content: center;
        align-items: center;
        content: '' !important;
        padding: 30px !important;
        background-color: transparent !important;
        border-left: none !important;
        overflow: hidden;
    }

    :deep(.custom-file-label) {
        outline: 2px dashed #e0e0e0 !important;
        outline-offset: -15px !important;
        border: 1px solid #e0e0e0 !important;
        height: 100% !important;
    }

    :deep(.custom-file-label:after) {
        display: none !important;
    }
</style>
